import {FaultData} from '@docma-mm-core/fault/fault-data';
import {ViewFault} from '@docma-mm-core/fault/fault';

export class FaultsEdit {
  faults: Map<number, ViewFault>;
  loadedFauls: FaultData[];
  changes: FaultData;
}

export class FaultsEditData {

  constructor(faults: FaultData[], faultIds: number[]) {
    const changes = new FaultData(faults[0]);
    this.patchData = changes;
    this.faults = faultIds.map(m => ({ Id: m }));
  }

  patchData: FaultData;
  faults: { Id: number }[] = [];
}
